import React from "react";

function Highlighter({ text, highlight }) {
  // Handle null, undefined, or non-string values
  if (!text || typeof text !== "string" || text.trim() === "") {
    return text || "";
  }

  if (!highlight || typeof highlight !== "string" || highlight.trim() === "") {
    return text;
  }

  try {
    const regex = new RegExp(`(${highlight})`, "gi");

    return text.split(regex).map((part, index) => {
      if (part.toLowerCase() === highlight.toLowerCase()) {
        return (
          <span key={index} className="bg-yellow-200 font-semibold">
            {part}
          </span>
        );
      }
      return part;
    });
  } catch (error) {
    // If regex fails (e.g., special characters), return original text
    // Regex error, fallback to non-highlighted text
    return text;
  }
}

export default Highlighter;
